/**
 * Fix: extend Prestige's native variant -> gallery-image syncing so it also works reliably
 * inside the horizontally-scrolling mobile carousel.
 *
 * Prestige's own product-gallery component (assets/theme.js, ProductGallery class) already
 * listens for the theme's "variant:change" event and tries to scroll its carousel to the
 * media matching the newly selected variant's featured_media. On some carousel/viewport
 * combinations that internal logic (gated behind a scrollWidth/clientWidth "isScrollable"
 * check plus a scrollLeft-equality guard) can silently no-op, so the visible slide never
 * updates even though the variant selection itself changed correctly.
 *
 * This listener acts as a robust, idempotent safety net: it re-reads the same event data
 * Prestige itself dispatches, finds the matching media cell inside the carousel that belongs
 * to the changed form, and calls the carousel's own public, native select() API to jump to
 * it. It does not reimplement scrolling, does not touch touch/swipe handling, and does not
 * hardcode any option, color, or hardware names - it is driven entirely by the variant's
 * assigned featured_media, exactly like Prestige's own code.
 */
(function () {
  document.addEventListener('variant:change', function (event) {
    var detail = event.detail || {};
    var variant = detail.variant;
    var previousVariant = detail.previousVariant;

    if (!variant || !variant.featured_media) {
      return;
    }

    if (
      previousVariant &&
      previousVariant.featured_media &&
      previousVariant.featured_media.id === variant.featured_media.id
    ) {
      return;
    }

    // Prestige dispatches "variant:change" directly on the product <form> element (see
    // VariantPicker in assets/theme.js), so event.target - not detail.formId - is the most
    // reliable way to identify which form/gallery pair this event belongs to. We deliberately
    // read the id via getAttribute() rather than the form's .id property: Shopify's own
    // add-to-cart form contains a hidden input named "id" (the selected variant id), and per
    // the standard HTML forms API, a named form control shadows the form element's own .id
    // property - so form.id can silently return that input element instead of the id string.
    // getAttribute('id') is unaffected by that quirk and always returns the real attribute.
    var form = event.target && typeof event.target.getAttribute === 'function' ? event.target : null;
    var formId = form ? form.getAttribute('id') : null;

    if (!formId && typeof detail.formId === 'string') {
      formId = detail.formId;
    }

    if (!formId) {
      return;
    }

    var galleries;
    try {
      galleries = document.querySelectorAll('product-gallery[form="' + CSS.escape(formId) + '"]');
    } catch (e) {
      return;
    }

    if (!galleries.length) {
      return;
    }

    var mediaId = String(variant.featured_media.id);

    galleries.forEach(function (gallery) {
      var carousel = gallery.carousel;
      if (!carousel || typeof carousel.select !== 'function') {
        return;
      }

      var cells = carousel.cells || [];
      var index = -1;
      for (var i = 0; i < cells.length; i++) {
        if (cells[i].getAttribute('data-media-id') === mediaId) {
          index = i;
          break;
        }
      }

      if (index === -1) {
        return;
      }

      carousel.select(index, { instant: true });
    });
  });
})();
